import { render, staticRenderFns } from "./RoomScordModal.vue?vue&type=template&id=e892ebba&"
import script from "./RoomScordModal.vue?vue&type=script&lang=js&"
export * from "./RoomScordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports